var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-wrapper',{attrs:{"space":"small"}},[_c('v-checkbox',{attrs:{"mandatory":"","input-value":_vm.field.isMultiline,"label":"Multi line text input"},on:{"change":_vm.toggleMultiline}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }